import React from 'react';
import PropTypes from 'prop-types';
import {
  AutoComplete,
  MenuItem,
} from 'material-ui';
import {
  choices,
  translate as t,
} from 'admin-on-rest';
import Accessible from 'material-ui/svg-icons/action/accessible';
import Assessment from 'material-ui/svg-icons/action/assessment';
import Assignment from 'material-ui/svg-icons/action/assignment';
import Event from 'material-ui/svg-icons/action/event';
import Flight from 'material-ui/svg-icons/maps/flight';
import CreditCard from 'material-ui/svg-icons/action/credit-card';
import Done from 'material-ui/svg-icons/action/done';
import Favorite from 'material-ui/svg-icons/action/favorite';
import Grade from 'material-ui/svg-icons/action/grade';
import Language from 'material-ui/svg-icons/action/language';
import LibraryMusic from 'material-ui/svg-icons/av/library-music';
import Call from 'material-ui/svg-icons/communication/call';
import Email from 'material-ui/svg-icons/communication/email';
import Restaurant from 'material-ui/svg-icons/maps/restaurant';
import LocalBar from 'material-ui/svg-icons/maps/local-bar';
import Group from 'material-ui/svg-icons/social/group';
import Receipt from 'material-ui/svg-icons/action/receipt';

const toDataSource = (value) => {
  const Icon = iconNameMap[value];
  return {
    text: value,
    value: (
      <MenuItem
        primaryText={`(${value})`}
        leftIcon={<Icon />}
      />
    ),
  };
};

export const iconNameMap = {
  accessible: Accessible,
  assessment: Assessment,
  assignment: Assignment,
  event: Event,
  travel: Flight,
  credit_card: CreditCard,
  done: Done,
  favorite: Favorite,
  star: Grade,
  language: Language,
  music: LibraryMusic,
  call: Call,
  email: Email,
  restaurant: Restaurant,
  drinks: LocalBar,
  group: Group,
  receipt: Receipt,
};

const iconValues = Object.keys(iconNameMap);

const dataSource = iconValues.map(toDataSource);

class IconPicker extends React.Component {
  state = {
    text: '',
    touched: false,
    errorText: null,
  }

  onChange = (text) => {
    const errorText = choices(iconValues, 'documents.icon.errorText')(text, null, this.props);
    if (!errorText || !text) {
      this.props.onChange(text);
    }
    this.setState({
      text,
      touched: true,
      errorText,
    });
  }

  filterIfSearchExist = (searchText, key) => !searchText || AutoComplete.caseInsensitiveFilter(searchText, key);

  render() {
    const { label, ...rest } = this.props;

    return (
      <AutoComplete
        floatingLabelText={label}
        errorText={this.state.touched && this.state.errorText}
        dataSource={dataSource}
        searchText={this.state.text}
        onUpdateInput={this.onChange}
        filter={this.filterIfSearchExist}
        menuProps={{ maxHeight: 250 }}
        openOnFocus
        {...rest}
      />
    );
  }
}

IconPicker.propTypes = {
  label: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

export default t(IconPicker);
